/** Texts of plans and the plan viewer (docs/architecture/plans.md). */
export const plansDe = {
  title: 'Pläne',
  count_one: '{{count}} Plan',
  count_other: '{{count}} Pläne',
  hint: 'PDF oder Bild, bis {{size}} pro Plan.',
  offline: 'Ohne Verbindung nur zum Ansehen.',
  offlineChanges: 'Ohne Verbindung: Änderungen gehen mit dem nächsten Abgleich an den Server.',
  unavailable: 'Ohne Verbindung sind die Pläne dieses Eintrags nicht verfügbar.',
  add: 'Plan hinzufügen',
  fromPhoto: 'Plan aus Foto',
  empty: 'Noch keine Pläne',
  emptyHint:
    'Grundrisse und Lagepläne als PDF oder Bild hinzufügen oder einen Plan abfotografieren.',
  open: '„{{name}}“ öffnen',
  actions: 'Aktionen für „{{name}}“',
  moveUp: '„{{name}}“ nach oben',
  moveDown: '„{{name}}“ nach unten',
  moved: '„{{name}}“ ist jetzt an Stelle {{position}} von {{count}}.',
  kinds: { pdf: 'PDF', image: 'Bild' },
  pdfPages_one: 'PDF mit {{count}} Seite',
  pdfPages_other: 'PDF mit {{count}} Seiten',
  pages_one: '{{count}} Seite',
  pages_other: '{{count}} Seiten',
  fileMissing: 'Datei fehlt',
  preview: 'Vorschau des Plans',
  addTitle: 'Plan hinzufügen',
  editTitle: 'Plan bearbeiten',
  added: 'Plan „{{name}}“ hinzugefügt',
  queued:
    'Plan „{{name}}“ gespeichert, die Datei wird hochgeladen, sobald eine Verbindung besteht.',
  saved: 'Plan „{{name}}“ gespeichert',
  removed: 'Plan „{{name}}“ entfernt',
  removeTitle: 'Plan „{{name}}“ entfernen?',
  removeDescription: 'Plan und Datei werden gelöscht, Standorte auf diesem Plan ebenso.',
  fields: {
    name: 'Bezeichnung',
    namePlaceholder: 'z. B. Grundriss Erdgeschoss',
    floor: 'Geschoss',
    floorPlaceholder: 'z. B. EG',
    notes: 'Notiz',
  },
  photo: {
    title: 'Plan aus Foto',
    alt: 'Foto des Plans',
    hint: 'Die vier Ecken auf die Ränder des Plans ziehen. Alles außerhalb wird abgeschnitten, der Plan wird rechtwinklig ausgerichtet. Mit der Tastatur: Ecke mit Tab wählen, mit den Pfeiltasten verschieben, mit Umschalt in großen Schritten.',
    topLeft: 'Ecke oben links',
    topRight: 'Ecke oben rechts',
    bottomRight: 'Ecke unten rechts',
    bottomLeft: 'Ecke unten links',
    invalid: 'Die Ecken ergeben kein Viereck. Jede Ecke auf eine Ecke des Plans ziehen.',
    straighten: 'Begradigen',
    skip: 'Ohne Korrektur übernehmen',
  },
  viewer: {
    label: 'Plan „{{name}}“',
    keys: 'Plus und Minus zoomen, 0 zeigt den ganzen Plan, die Pfeiltasten verschieben ihn, Bild auf und Bild ab blättern.',
    pickKeys: 'Die Eingabetaste setzt den Standort in die Mitte.',
    pickHint: 'Auf die Stelle im Plan tippen',
    marker: 'Standort {{labels}}',
    zoomIn: 'Vergrößern',
    zoomOut: 'Verkleinern',
    fit: 'Ganzen Plan zeigen',
    loading: 'Plan wird geladen …',
    missing: 'Die Datei dieses Plans ist noch nicht hochgeladen.',
    offline: 'Die Datei ist ohne Verbindung auf diesem Gerät nicht verfügbar.',
    failed: 'Der Plan lässt sich nicht anzeigen.',
    page: 'Seite {{page}} von {{count}}',
    previous: 'Vorherige Seite',
    next: 'Nächste Seite',
  },
  picker: {
    title: 'Standort setzen',
    editTitle: 'Standort ändern',
    plan: 'Plan',
    chosen: 'Standort auf Seite {{page}} gesetzt. Zum Ändern erneut tippen.',
    label: 'Bezeichnung des Standorts',
    labelHint: 'Hilft, mehrere Standorte auseinanderzuhalten.',
    labelPlaceholder: 'z. B. Tür zum Treppenhaus Nord',
    apply: 'Standort übernehmen',
    draft: 'Neu',
    none: 'Keine Pläne',
    noneHint: 'Für diesen Eintrag gibt es noch keine Pläne oder sie sind nicht auf dem Gerät.',
  },
  errors: {
    addFailed: '„{{name}}“ konnte nicht als Plan gespeichert werden.',
    unreadable:
      '„{{name}}“ lässt sich nicht öffnen. Bitte ein unbeschädigtes PDF oder Bild wählen.',
    straightenFailed:
      'Das Foto ließ sich nicht begradigen. Bitte erneut versuchen oder ohne Korrektur übernehmen.',
    'too-many-plans': 'Ein Eintrag hat höchstens {{max}} Pläne.',
    'version-conflict': 'Der Plan wurde inzwischen geändert. Die aktuelle Fassung ist geladen.',
    orderFailed: 'Die Reihenfolge wurde nicht gespeichert.',
    removeFailed: '„{{name}}“ konnte nicht entfernt werden.',
  },
};
